import {Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {TranslateService} from '@ngx-translate/core';
import {MyStorageService} from '../../services/common/my-storage.service';
import {Constants} from '../../utils/constants';
import {CoreDataService} from '../../services/wrapper/core-data.service';
import {StompSockService, WsCommand} from '@oril/ng-stomp-sock';
import {filter} from 'rxjs/operators';
import {RestaurantService} from '../../services/restaurant.service';
import {NotificationService} from '../../services/common/notification.service';
import {BroadcastPayload, WebsocketNotificationService} from '../../services/common/websocket-notification.service';
import {PushNotificationsService} from 'ng-push-ivy';
import {Utilities} from '../../utils/utilities';
import {ReservationService} from '../../services/reservation.service';
import {DashboardMessageService} from '../../services/dashbarod-message.service';
import Swal from 'sweetalert2';

const misc: any = {
    sidebar_mini_active: true
};

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
    public languages: any[];
    private toggleButton: any;
    public isCollapsed = true;
    public authUser: any;
    public title = 'Makery dashboard';
    public notificationKey = WebsocketNotificationService.NOTIFICATION_COOKIE_KEY;
    public DRAFTNotificationKey = WebsocketNotificationService.DRAFT_COOKIE_KEY;
    public DASHBOARDMessageNotificationKey = WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY;

    private restaurants: any[];
    private translatedKeys: any = {};
    hasOrderRule: boolean;
    reservationAudio;
    orderAudio;
    deliveryAudio;
    isProduction = false;
    draftReservations: any[] = [];
    private try = 0;
    dashboardMessage: any[] = [];

    constructor(
        private location: Location,
        private element: ElementRef,
        private router: Router,
        private keycloakService: KeycloakService,
        private myStorage: MyStorageService,
        public translateService: TranslateService,
        private coreDataService: CoreDataService,
        private webSocketService: StompSockService,
        private notificationService: NotificationService,
        private restaurantService: RestaurantService,
        public websocketNotificationService: WebsocketNotificationService,
        private pushNotification: PushNotificationsService,
        private reservationService: ReservationService,
        private dashboardMessageService: DashboardMessageService
    ) {
        this.location = location;
        this.keycloakService.getKeycloakInstance().loadUserProfile().then(result => {
            this.authUser = result;
        });
        this.hasOrderRule = this.keycloakService.getUserRoles().includes('admin');
        this.pushNotification.requestPermission();
        this.reservationAudio = new Audio('assets/reservation.mp3');
        this.orderAudio = new Audio('assets/order.mp3');
        this.deliveryAudio = new Audio('assets/delivery.mp3');
    }

    private initData() {
        const restaurantHistoryIds = this.restaurants.map(restaurant => restaurant.historyId);
        this.reservationService.getAllDraftByRestaurantHistoryIdAndReservationDate(restaurantHistoryIds, new Date()).subscribe(result => {
            this.websocketNotificationService.deleteAllNotification(WebsocketNotificationService.DRAFT_COOKIE_KEY);
            result.forEach(reservation => {
                this.websocketNotificationService.addNotification(
                    {type: reservation.type, attribute: reservation, subscribePath: '', subscriber: ''},
                    WebsocketNotificationService.DRAFT_COOKIE_KEY
                );
            });
        });
        this.dashboardMessageService.getAllForNavBar().subscribe(result => {
            this.deleteNotVisibleDashboardMessage();
            result.forEach(dashboardMessage => {
                this.websocketNotificationService.addNotification(
                    {type: 'DASHBOARD_MESSAGE', attribute: dashboardMessage, subscribePath: '', subscriber: ''},
                    WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY
                );
            });
            this.dashboardMessageHandler();
        });
        this.connectToAPI();

        this.websocketNotificationService.getNotifications(WebsocketNotificationService.NOTIFICATION_COOKIE_KEY);
        this.websocketNotificationService.getNotifications(WebsocketNotificationService.DRAFT_COOKIE_KEY);
        this.websocketNotificationService.getNotifications(WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY);


        this.isProduction = Utilities.isProduction();
        this.initTranslations();
    }

    private initTranslations() {
        this.translateService.get('general.newOrder').subscribe((translated: string) => {
            this.translatedKeys['general.newOrder'] = translated;
            this.translatedKeys.ADD_RESERVATION = this.translateService.instant('general.reservationStatus.ADD_RESERVATION');
            this.translatedKeys.ADD_DELIVERY = this.translateService.instant('general.reservationStatus.ADD_DELIVERY');
            this.translatedKeys.UPDATE_RESERVATION = this.translateService.instant('general.reservationStatus.UPDATE_RESERVATION');
            this.translatedKeys.UPDATE_DELIVERY = this.translateService.instant('general.reservationStatus.UPDATE_DELIVERY');
            this.translatedKeys.ADD_NOTE = this.translateService.instant('general.reservationStatus.ADD_NOTE');
            this.translatedKeys.STATUS_CHANGE_DELIVERY = this.translateService.instant('general.reservationStatus.STATUS_CHANGE_DELIVERY');
            this.translatedKeys.STATUS_CHANGE_ACCEPT = this.translateService.instant('general.reservationStatus.STATUS_CHANGE_ACCEPT');
            this.translatedKeys.STATUS_CHANGE_PENDING = this.translateService.instant('general.reservationStatus.STATUS_CHANGE_PENDING');
            this.translatedKeys.STATUS_CHANGE_SUCCESS = this.translateService.instant('general.reservationStatus.STATUS_CHANGE_SUCCESS');
            this.translatedKeys.STATUS_CHANGE_NOT_ARRIVED = this.translateService.instant('general.reservationStatus.STATUS_CHANGE_NOT_ARRIVED');
            this.translatedKeys.STATUS_CHANGE_DECLINE = this.translateService.instant('general.reservationStatus.STATUS_CHANGE_DECLINE');
            this.translatedKeys.UPDATE_GUEST = this.translateService.instant('general.reservationStatus.UPDATE_GUEST');
        });
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async ngOnInit() {
        do {
            this.languages = this.coreDataService.getLanguages();
            this.restaurants = this.restaurantService.getUsersRestaurants();
            await this.sleep(1000);
            this.try++;
        } while (this.restaurants.length < 1 && this.try <= 4)

        this.initData();

    }

    public connectToAPI() {
        this.webSocketService.connected$
            .pipe(filter(connected => !!connected))
            .subscribe(() => this.connectToEndpoint());
    }

    public connectToEndpoint() {
        if (this.hasOrderRule) {
            this.orderNotification();
        }
        this.dashboardMessageNotification();
        this.restaurants.forEach(restaurant => {
            this.webSocketService.getWebSocket(this.websocketNotificationService.reservationEndpoint + '/' + restaurant.historyId).on<any>(WsCommand.MESSAGE)
                .subscribe((response: BroadcastPayload) => {
                    Utilities.log(response);
                    if (response.type.indexOf('POSTPONE') == -1) {
                        this.draftNotificationHandler(response);
                        this.notificationHandler(response);
                    } else {
                        Utilities.log(response);
                    }
                });
        });
    }

    private notificationHandler(response: BroadcastPayload) {
        if (!WebsocketNotificationService.NOTIFICATION_TYPE_BLACK_LIST.includes(response.type) && response.subscriber != this.authUser.email) {
            const audio = (response.type.indexOf('DELIVERY') > -1 ? this.deliveryAudio : this.reservationAudio);
            this.notifyBrowser(this.translatedKeys[response.type], response.attribute.billingData.firstName + ' ' + response.attribute.billingData.lastName, audio, response.attribute.id);
            this.notificationService.showSocketNotification('general.reservationStatus.' + response.type, response.attribute.billingData.firstName + ' ' + response.attribute.billingData.lastName);
            this.websocketNotificationService.addNotification(response, WebsocketNotificationService.NOTIFICATION_COOKIE_KEY);
        }
    }

    private draftNotificationHandler(response: BroadcastPayload) {
        if (response.attribute.reservationStatus == 'DRAFT') {
            this.websocketNotificationService.addNotification(response, WebsocketNotificationService.DRAFT_COOKIE_KEY);
        } else {
            this.websocketNotificationService.deleteNotification(response.attribute.id, WebsocketNotificationService.DRAFT_COOKIE_KEY);
        }
    }

    private orderNotification() {
        this.webSocketService.getWebSocket(this.websocketNotificationService.orderEndpoint).on<any>(WsCommand.MESSAGE)
            .subscribe((response: BroadcastPayload) => {
                this.notifyBrowser(this.translatedKeys.newOrder, response.attribute.billingData.firstName + ' ' + response.attribute.billingData.lastName, this.orderAudio, response.attribute.id);
                this.notificationService.showSocketNotification('general.newOrder', response.attribute.billingData.firstName + ' ' + response.attribute.billingData.lastName);
                this.websocketNotificationService.addNotification(response, WebsocketNotificationService.NOTIFICATION_COOKIE_KEY);
            });
    }

    private dashboardMessageNotification() {
        this.webSocketService.getWebSocket(this.websocketNotificationService.dashboardMessageEndpoint).on<any>(WsCommand.MESSAGE)
            .subscribe((response: BroadcastPayload) => {
                this.showDashboardMessage(response);
                this.websocketNotificationService.addNotification(response, WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY,true);
            });
    }

    notifyBrowser(body, title, audio, id) {
        const options = {
            body,
            tag: id,
            icon: 'assets/img/favicon.png'
        };
        this.pushNotification.create(title, options).subscribe(
            res => {
                if (res.event.type === 'click') {
                    this.notificationClick(res.notification);
                } else {
                    audio.play();
                }
            },
            err => console.log(err)
        );
    }

    logout() {
        this.keycloakService.logout();
    }

    switchLang(lang: string) {
        this.translateService.use(lang);
        this.myStorage.saveToCookies(Constants.STORAGE_KEYS.LANGUAGE, lang);
        window.location.reload();
    }

    getTitle() {
        let titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }
        const titleList = [];
        titlee.split('/').forEach(value => {
            if (value.length > 0) {
                titleList.push(value);
            }
        });
        if (titleList.length < 1) {
            return 'Dashboard';
        }
        return titleList[0];
    }

    minimizeSidebar() {
        const body = document.getElementsByTagName('body')[0];
        misc.sidebar_mini_active = body.classList.contains('sidebar-mini');
        if (misc.sidebar_mini_active === true) {
            body.classList.remove('sidebar-mini');
            misc.sidebar_mini_active = false;
        } else {
            body.classList.add('sidebar-mini');
            misc.sidebar_mini_active = true;
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const body = (
            document.getElementsByTagName('body')[0]
        ) as HTMLElement;
        const html = document.getElementsByTagName('html')[0];
        if (window.innerWidth < 991) {
            body.style.position = 'fixed';
        }

        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);

        html.classList.add('nav-open');
        const $layer = document.createElement('div');
        $layer.setAttribute('id', 'bodyClick');


        if (html.getElementsByTagName('body')) {
            document.getElementsByTagName('body')[0].appendChild($layer);
        }
        const $toggle = document.getElementsByClassName('navbar-toggler')[0];
        $layer.onclick = function () { // asign a function
            html.classList.remove('nav-open');
            setTimeout(function () {
                $layer.remove();
                $toggle.classList.remove('toggled');
            }, 400);
            const mainPanel = document.getElementsByClassName('main-panel')[0] as HTMLElement;

            if (window.innerWidth < 991) {
                setTimeout(function () {
                    mainPanel.style.position = '';
                }, 500);
            }
        }.bind(this);

        html.classList.add('nav-open');
    }

    sidebarClose() {
        const html = document.getElementsByTagName('html')[0];
        this.toggleButton.classList.remove('toggled');
        const body = (
            document.getElementsByTagName('body')[0]
        ) as HTMLElement;

        if (window.innerWidth < 991) {
            setTimeout(function () {
                body.style.position = '';
            }, 500);
        }
        const $layer: any = document.getElementById('bodyClick');
        if ($layer) {
            $layer.remove();

        }
        html.classList.remove('nav-open');
    }

    public disconnect() {
        // this.webSocketService.unsubscribe(this.endpoint);
    }

    ngOnDestroy(): void {
        this.disconnect();
    }

    private notificationClick(event: any) {
        const data = this.websocketNotificationService.getNotificationByKey(event.tag, WebsocketNotificationService.NOTIFICATION_COOKIE_KEY);
        if (data.data.type.indexOf('DELIVERY') > -1) {
            this.router.navigate(['/reservations/delivery/' + data.data.attribute.restaurant.historyId + '/' + event.tag]);
            window.focus()
        } else if (data.data.type.indexOf('RESERVATION') > -1) {
            this.router.navigate(['/reservations/restaurant/' + data.data.attribute.restaurant.historyId + '/' + event.tag]);
            window.focus()
        } else {
            this.router.navigate(['/orders/shop-orders/' + event.tag]);
            window.focus()
        }

    }


    private async dashboardMessageHandler(): Promise<void> {
        const map = this.websocketNotificationService.notificationElements
            .get(WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY);
        for (const value of map.values()) {
            if (!value.read) {
                await this.showDashboardMessage(value.data)
                this.websocketNotificationService.addNotification(
                    value.data,
                    WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY,
                    true
                );
            }
        }
    }

    private async showDashboardMessage(data: BroadcastPayload): Promise<any> {
        return Swal.fire(
            data.attribute.localizations[this.translateService.currentLang].title,
            data.attribute.localizations[this.translateService.currentLang].message,
            'info');
    }

    private deleteNotVisibleDashboardMessage() {
        const date = new Date();
        const map = this.websocketNotificationService.notificationElements
            .get(WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY);
        this.websocketNotificationService.deleteAllNotification(WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY);

        map.forEach(value => {
            const visibilityEndDate = Utilities.getDate(value.data.attribute.visibilityEnd);
            if (visibilityEndDate.getTime() > date.getTime()) {
                this.websocketNotificationService.addNotification(value.data, WebsocketNotificationService.DASHBOARD_MESSAGE_COOKIE_KEY, value.read);
            }
        });
    }

    getDate(s: any): Date {
        return Utilities.getDate(s);
    }
}
